<template>
    <div class="container">
        <div class="columns">
            <div class="column">
                <p class="title is-size-6-touch is-size-4-desktop">
                    <strong>Civic Centre</strong>
                </p>
                <p class>
                    163 St Vincent Street,
                    <br />Port Adelaide SA 5015
                </p>
                <p class>(08) 84056600</p>
                <p>
                    <a class href="mailto:service@cityofpae.sa.gov.au"
                        >service@cityofpae.sa.gov.au</a
                    >
                </p>
                <p style="margin-top: 1em;">
                    PO Box 110
                    <br />Port Adelaide SA 5015
                </p>
                <p style="margin-top: 1em;">ABN 68 399 090 894</p>

                <div class="footer-social-icons">
                    <h4 class="_14">Follow us on</h4>
                    <ul class="social-icons">
                        <li>
                            <a
                                target="_blank"
                                href="mailto:service@cityofpae.sa.gov.au"
                                class="social-icon"
                            >
                                <i class="fa fa-envelope"></i>
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://www.facebook.com/CityOfPAE"
                                class="social-icon"
                            >
                                <i class="fab fa-facebook"></i>
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="http://twitter.com/cityofpae"
                                class="social-icon"
                            >
                                <i class="fab fa-twitter"></i>
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="http://instagram.com/cityofpae"
                                class="social-icon"
                            >
                                <i class="fab fa-instagram"></i>
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://www.youtube.com/channel/UCf9dmxWIAq8AT_j-FZ_Wh3Q"
                                class="social-icon"
                            >
                                <i class="fab fa-youtube"></i>
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://www.linkedin.com/company/city-of-port-adelaide-enfield"
                                class="social-icon"
                            >
                                <i class="fab fa-linkedin"></i>
                            </a>
                        </li>
                    </ul>
                </div>

                <hr />

                <p>
                    <strong>Town Hall</strong>
                </p>
                <p>34 Nile Street, Port Adelaide</p>

                <p style="margin-top: 1em;">
                    <strong>Council Chambers</strong>
                </p>
                <p>62 Commercial Road, Port Adelaide</p>

                <p style="margin-top: 1em;">
                    <strong>Visitor Information Centre</strong>
                </p>
                <p>66 Commercial Rd, Port Adelaide</p>
                <p>8405 6560</p>
            </div>

            <div class="column">
                <p class="title is-size-6-touch is-size-5-desktop">
                    <strong>Public Libraries</strong>
                </p>
                <p class>
                    <strong>Enfield Library - Council Office</strong>
                </p>
                <p class>1 Kensington Cres, Enfield</p>
                <p class>8405 6530</p>
                <p class>
                    <strong>Greenacres Library - Council Office</strong>
                </p>
                <p class>2 Fosters Rd, Greenacres</p>
                <p class>8405 6540</p>

                <p class>
                    <strong>Parks Library</strong>
                </p>
                <p class>46 Trafford St, Angle Park</p>
                <p class>8405 6550</p>

                <p class>
                    <strong>Port Adelaide Library - Council Office</strong>
                </p>
                <p class>2-4 Church St, Port Adelaide</p>
                <p class>8405 6580</p>
                <p class>
                    <strong>Semaphore Library - Council Office</strong>
                </p>
                <p class>14 Semaphore Rd, Semaphore</p>
                <p class>8405 6570</p>

                <p
                    class="title is-size-6-touch is-size-5-desktop"
                    style="margin-top: 1rem;"
                >
                    <strong>Depots</strong>
                </p>
                <p class>
                    <strong>Kilburn Depot</strong>
                </p>
                <p class>Mill Ct, Kilburn</p>
                <p class>8405 6636</p>
                <p class>
                    <strong>Rellum Road Depot</strong>
                </p>
                <p class>Rellum Rd, Greenacres</p>
                <p class>8405 6015</p>
                <p class>8369 0292 (Emergency Line)</p>
                <p class>
                    <strong>Willochra Street Depot</strong>
                </p>
                <p class>Willochra Street, Largs Bay</p>
                <p class>8405 6905</p>
            </div>

            <div class="column">
                <p class="title is-size-6-touch is-size-5-desktop">
                    <strong>Community and Sports Centres</strong>
                </p>
                <p class>
                    <strong>Lefevre Community Stadium</strong>
                </p>
                <p class>Cnr Victoria Rd and Marmora Tce, Osborne</p>
                <p class>8405 6908</p>

                <p class>
                    <strong>The Lights Community and Sports Centre</strong>
                </p>
                <p class>
                    244 - 270 East Parkway, Lightsview<br />
                    <small>(Corner Hampstead Road and East Parkway)</small>
                </p>
                <p class>8405 6670</p>

                <p class>
                    <strong>Enfield Community Centre</strong>
                </p>
                <p class>540 Regency Rd, Enfield</p>
                <p class>8405 6556</p>
                <p class>
                    <strong>Kilburn Community Centre</strong>
                </p>
                <p class>59 Gladstone Ave, Kilburn</p>
                <p class>8405 6730</p>
            </div>
        </div>

        <img
            style="margin-top: 3em; max-width: 180px;"
            src="/images/pae-logo.png"
        />
    </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ui/Footer.vue